export default __webpack_public_path__ + "static/media/All-Purpose-Paint.050da3fa.png";